import { render } from "./Appointments.vue?vue&type=template&id=5e47b5b8&scoped=true"
import script from "./Appointments.vue?vue&type=script&lang=js"
export * from "./Appointments.vue?vue&type=script&lang=js"

import "./Appointments.vue?vue&type=style&index=0&id=5e47b5b8&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e47b5b8"]])

export default __exports__